import styled from 'styled-components'

export const SignCountDiv = styled.div`
  background-color: white;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  ${'' /* opacity: 0.7; */} -webkit-box-shadow: 2px 3px 5px 0px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 2px 3px 5px 0px rgba(0, 0, 0, 0.75);
  box-shadow: 2px 3px 5px 0px rgba(0, 0, 0, 0.75);
  cursor: pointer;
  position: relative;
  border-width: 3px;
  border-style: solid;
  border-color: ${props => props.theme};

  &:active {
    -moz-box-shadow: inset 0 0 10px #000000;
    -webkit-box-shadow: inset 0 0 10px #000000;
    box-shadow: inset 0 0 10px #000000;
  }

  & div {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  & p {
    margin: 0;
    padding: 0;
    color: ${props => props.theme};
  }

  & p:first-of-type {
    color: ${props => props.numberColor};
  }
`



// WEBPACK FOOTER //
// ./src/components/Map/styles/SignCounts.js